// extracted by mini-css-extract-plugin
module.exports = {"element":"Group_element__1J783","selected":"Group_selected__2c75E","imagecontainer":"Group_imagecontainer__16G0y","image":"Group_image__UPAfE","label":"Group_label__15emm"};